import { Spacer, Text } from "@zapier/design-system";

import { Currency, defaultCurrency } from "@zapier/currency";
import { hiddenOnMobile } from "@/utils";
import { Price } from "../../shared/Price";

type PlanPriceProps = {
  /** Price in USD pennies (i.e. hundredths of a USD dollar) */
  children: number;
  /** Currency to show price in */
  currency?: Currency;
  isAnnual?: boolean;
  showPriceTitle?: boolean;
};

/**
 * Displays a price in a styled and user-friendly format.
 */
export const PlanPrice = ({
  showPriceTitle = true,
  isAnnual,
  children,
  currency = defaultCurrency,
}: PlanPriceProps) => {
  const isFree = children === 0;
  return (
    <div>
      {showPriceTitle ? (
        <div>
          <Text type="smallPrint1">Starting from</Text>
        </div>
      ) : (
        <div css={hiddenOnMobile}>
          <Spacer height={21} />
        </div>
      )}

      <Price currency={currency} isAnnual={isAnnual}>
        {children}
      </Price>

      {isFree ? (
        <Text type="smallPrint1Medium">Free forever</Text>
      ) : (
        isAnnual && <Text type="smallPrint1Medium">Billed annually</Text>
      )}
    </div>
  );
};
